import AuthAPI from "./auth.js";
const Auth = new AuthAPI();

// Public
export function idTypes() {
	return Auth.GET(`/Notarization/Signers/IdentityDocument/Types`);
}

export function uploadId({ file, isFrontImage, identityDocumentTypeId }, notarizationId, signerId) {
	return Auth.POSTFile(url(notarizationId, signerId), { file, isFrontImage, identityDocumentTypeId });
}

export function getIdDocument(notarizationId, signerId) {
	return Auth.GET(url(notarizationId, signerId));
}
export function getIdDetails(notarizationId, signerId) {
	return Auth.GET(`${url(notarizationId, signerId)}/Details`);
}

//export function idThumbnailUrl(fileContainer, fileIdentifier, width=560, height=340) {
//	return `${window.Notary.Config.ApiUrlBase}/API/Thumbnail/${fileContainer}/${fileIdentifier}?width=${width}&height=${height}`;
//}

export function idThumbnailBlob(notarizationId, fileContainer, fileIdentifier, width = 560, height = 340) {
	return Auth.GETblob(`/Thumbnail/${notarizationId}/${fileContainer}/${fileIdentifier}?width=${width}&height=${height}`);
}

export function removeId(notarizationId, signerId, body) {
	return Auth.DELETE(url(notarizationId, signerId), body);
}

export function verifyId(notarizationId, signerId) {
	return Auth.POST(verifyUrl(notarizationId, signerId));
}

export function getIdVerificationResult(notarizationId, signerId) {
	return Auth.GET(verifyUrl(notarizationId, signerId));
}

export class IdentityDocumentRemoveRequest {
	constructor(removeFront, removeBack, idDocument) {
		this.removeFront = removeFront;
		this.removeBack = removeBack;
		if (removeFront) {
			this.imageFrontFileContainer = idDocument.imageFrontFileContainer;
			this.imageFrontFileIdentifier = idDocument.imageFrontFileIdentifier;
		}
		if (removeBack) {
			this.imageBackFileContainer = idDocument.imageBackFileContainer;
			this.imageBackFileIdentifier = idDocument.imageBackFileIdentifier;
		}
	}
}

// Private
function url(notarizationId, signerId) {
	return `/Notarization/${notarizationId}/Signers/${signerId}/IdentityDocument`;
}

function verifyUrl(notarizationId, signerId) {
	return `${url(notarizationId, signerId)}/Verification`;
}